var $33aba885fd306c4d$exports = {};
$33aba885fd306c4d$exports = {
    "pending": `\u{5DE}\u{5DE}\u{5EA}\u{5D9}\u{5DF} \u{5DC}`
};


export {$33aba885fd306c4d$exports as default};
//# sourceMappingURL=he-IL.module.js.map
